function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')

    a.href = url
    a.download = filename
    a.style.display = 'none'

    document.body.appendChild(a)
    a.click()

    setTimeout(() => {
        URL.revokeObjectURL(url)
        a.remove()
    }, 0)
}

export {
    downloadBlob,
}
